<template xmlns:v-swiper="http://www.w3.org/1999/xhtml">
  <div>
    <div class="main main-custom">
      <div class="primarylists">
        <ul class="container">
          <li v-if="!this.isMobileFlg">
            <table class="flex-table">
              <tr>
                <td class="lkt-title">1. Truy cập vào link study-arts.vn</td>
              </tr>
              <tr>
                <td class="lkt-title">2. Chuyển đổi ngôn ngữ hiển thị</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\manual-1.png" alt="" /></td>
              </tr>
              <tr>
                <td>
                  Nhấn vào biểu tượng quốc kỳ ở thanh menu chính của phần trên màn hình, rồi
                  chọn 1 trong 4 ngôn ngữ được hiển thị.
                </td>
              </tr>
              <tr>
                <td class="lkt-title">3. Đăng nhập</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\manual-2.png" alt="" /></td>
              </tr>
              <tr>
                <td>
                  ① Nhấn vào biểu tượng Đăng nhập ở thanh menu chính của phần trên màn hình,
                  thì màn hình dùng để nhập thông tin đăng nhập sẽ được hiển thị.
                </td>
              </tr>
              <tr>
                <td>② Nhập thông tin vào ô Tài khoản và Mật khẩu ở màn hình đó</td>
              </tr>
              <tr>
                <td>③ Nhấn nút [Đăng nhập], thì xử lý đăng nhập sẽ được thực hiện</td>
              </tr>
              <tr>
                <td>
                  ※ Nếu đánh dấu vào ô Lưu trạng thái đăng nhập, thì vào lần đăng nhập tiếp
                  theo, trạng thái tài khoản và mật khẩu đã lưu sẽ được cập nhật lại khi
                  nhấn vào tiêu đề Tài khoản trên đầu màn hình popup.
                </td>
              </tr>
              <tr>
                <td class="lkt-title">4. Thay đổi mật khẩu</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\manual-3.png" alt="" /></td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\manual-4.png" alt="" /></td>
              </tr>
              <tr>
                <td>
                  ① Nhấn vào biểu tượng Người dùng ở góc phải màn hình, thì màn hình quản lý
                  thông tin người dùng sẽ được hiển thị.
                </td>
              </tr>
              <tr>
                <td>
                  ② Nhấn vào nút [Đổi mật khẩu] từ menu bên trái màn hình, thì khung thay
                  đổi mật khẩu sẽ được hiển thị bên phải.
                </td>
              </tr>
              <tr>
                <td>
                  ③ Sau khi nhập vào các ô [Mật khẩu hiện tại], [Mật khẩu mới], [Mật khẩu
                  mới (Xác nhận)], rồi nhấn nút [Lưu mật khẩu]
                </td>
              </tr>
              <tr>
                <td class="lkt-title">5.Tham gia khóa học</td>
              </tr>
              <tr>
                <td><i>5.1. Chọn khóa học</i></td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\manual-5.png" alt="" /></td>
              </tr>
              <tr>
                <td>
                  ① Nhấn vào khóa học muốn học được hiển thị trên trang chủ hoặc tìm kiếm
                  bằng từ khóa liên quan trong ô tìm kiếm.
                </td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\manual-6.png" alt="" /></td>
              </tr>
              <tr>
                <td>
                  ② Nhấn vào khóa học muốn học, sẽ di chuyển đến màn hình chi tiết khóa học
                </td>
              </tr>
              <tr>
                <td>
                  ③ Từ lần login sau, những khóa học đã tham gia sẽ được hiển thị trong Khóa
                  học của tôi theo thứ tự ngày tham gia.
                </td>
              </tr>
              <tr>
                <td><i>5.2 Xem nội dung</i></td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\manual-7.png" alt="" /></td>
              </tr>
              <tr>
                <td>
                  ① Ở màn hình Khái quát khóa học, nhấn nút [Bắt đầu khóa học], di chuyển
                  đến màn hình Mục lục khóa học
                </td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\manual-8.png" alt="" /></td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\manual-9.png" alt="" /></td>
              </tr>
              <tr>
                <td>
                  ② Nhấn vào 1 bài học trong Mục lục bài học, rồi học nội dung bài học đó.
                </td>
              </tr>
              <tr>
                <td>
                  ③ Có thể chuyển đổi nội dung bằng các biểu tượng mũi tên hoặc chọn số
                  trang muốn học trong ô chọn trang.
                </td>
              </tr>
              <tr>
                <td>
                  ※ Khi nhấn vào bài học bất kỳ thì bài học đó được xem như là đang học, và
                  chuyển từ màu đen sang màu đỏ.
                </td>
              </tr>
              <tr>
                <td>
                  Nếu tất cả trang nội dung của từng bài học được hiển thị hết thì biểu
                  tượng bài học sẽ chuyến thành màu xanh lá cây.
                </td>
              </tr>
              <tr>
                <td>
                  ④ Có thể gửi câu hỏi liên quan đến bài học đang học cho giáo viên thông
                  qua chức năng Trao đổi
                </td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\manual-10.png" alt="" /></td>
              </tr>
              <tr>
                <td>
                  ⑤ Có thể vừa học vừa ghi lại những lưu ý liên quan đến bài thông qua chức
                  năng Ghi chú
                </td>
              </tr>
              <tr>
                <td>
                  ⑥ Cũng có thể xuất ghi chú tổng hợp của tất cả các bài học của khóa học
                  bằng cách nhấn nút [Xuất ghi chú] ở trên thanh menu con ở trang mục lục
                  của khóa học
                </td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\manual-11.png" alt="" /></td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\manual-12.png" alt="" /></td>
              </tr>
              <tr>
                <td>5.3 Bài tập</td>
              </tr>
              <tr>
                <td>
                  ① Biểu tượng Bài tập sẽ được hiển thị ở cột Bài tập trong mỗi bài học. Khi
                  nhấn biểu tượng Bài tập, thì sẽ di chuyển đến màn hình làm Bài tập
                </td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\manual-13.png" alt="" /></td>
              </tr>
              <tr>
                <td>
                  ② Hoặc có thể làm bài tập từ trang bài học cụ thể bằng cách nhấn vào biểu
                  tượng Bài tập ở góc phải phải phía trên màn hình.
                </td>
              </tr>
              <tr>
                <td>
                  Nếu không có biểu tượng bài tập thì có nghĩa là bài học đó không có bài
                  tập.
                </td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\manual-14.png" alt="" /></td>
              </tr>
              <tr>
                <td>③ Xác nhận nội dung câu hỏi, rồi chọn đáp án từ các lựa chọn.</td>
              </tr>
              <tr>
                <td>④ Nhấn nút [Chấm bài] để nộp bài tập.</td>
              </tr>
              <tr>
                <td>
                  ※ Sau chi nộp bài thì biểu tượng Bài tập sẽ chuyển từ màu đen sang màu đỏ.
                </td>
              </tr>
              <tr>
                <td>
                  Sau khi bài tập được chấm thì biểu tượng Bài tập sẽ chuyển từ màu đỏ sang
                  màu xanh lá cây, và đồng thời xuất hiện tỉ lệ % ở cột Tỷ lệ điểm
                </td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\manual-15.png" alt="" /></td>
              </tr>
              <tr>
                <td>
                  ⑤ Kết quả chấm điểm được hiển thị thành phần trăm % ở cột Tỷ lệ điểm bên
                  cạnh cột Bài tập.
                </td>
              </tr>
              <tr>
                <td>
                  Có thể kiểm tra lại đáp án của câu hỏi bằng cách nhấn vào biểu tượng % bên
                  cạnh biểu tượng Bài tập,
                </td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\manual-16.png" alt="" /></td>
              </tr>
              <tr>
                <td>
                  ※ Bài tập không phải là đối tượng để đánh giá tiến độ học tập hay thành
                  tích họp tập. Cho dù không làm bài tập thì vẫn có thể tiếp tục học và làm
                  bài thi cuối kỳ.
                </td>
              </tr>
              <tr>
                <td><i>5.4 Bài thi cuối kỳ</i></td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\manual-17.png" alt="" /></td>
              </tr>
              <tr>
                <td>
                  ① Khi học xong toàn bộ nội dung trong danh sách bài học, thì biểu tượng
                  Bài thi cuối kỳ sẽ được hiển thị trên đầu trang.
                </td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\manual-18.png" alt="" /></td>
              </tr>
              <tr>
                <td>
                  ② Nhấn nút [Bắt đầu kiểm tra], thì Bài thi cuối kỳ sẽ bắt đầu. Khi nhấn
                  nút [Hủy], thì sẽ quay trở lại màn hình Mục lục bài học.
                </td>
              </tr>
              <tr>
                <td>
                  ※ Có thể làm Bài thi cuối kỳ nhiều lần. Việc phán đoán Đỗ/Không đỗ sẽ dựa
                  vào thành tích cuối cùng.
                </td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\manual-19.png" alt="" /></td>
              </tr>
              <tr>
                <td>
                  ③ Có thể chuyển đổi câu hỏi bằng biểu tượng mũi tên hoặc nhấn vào số câu
                  hỏi bên dưới. Khi nhấn nút [Nộp bài], thì sẽ di chuyển đến màn hình xác
                  nhận tình trạng trả lời.
                </td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\manual-20.png" alt="" /></td>
              </tr>
              <tr>
                <td>
                  ④ Kiểm ra lại tất cả các câu trả lời ở màn hình xác nhận tình trạng câu
                  trả lời, rồi nhấn nút [Nộp bài], thì hộp thoại xác nhận nộp bài sẽ được
                  hiển thị.
                </td>
              </tr>
              <tr>
                <td>
                  ⑤ Khi nhấn nút [OK], thì câu trả lời sẽ được nộp, và Bài thi cuối kỳ sẽ
                  kết thúc.
                </td>
              </tr>
              <tr>
                <td class="lkt-title">6. Bảng cam kết</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\manual-21.png" alt="" /></td>
              </tr>
              <tr>
                <td>
                  ① Nếu đỗ Kì thi cuối kỳ thì % tiến độ sẽ tăng lên. Nhấn vào link [Bản cam
                  kết] trên thanh menu con, thì màn hình Bản cam kết sẽ được hiển thị.
                </td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\manual-22.png" alt="" /></td>
              </tr>
              <tr>
                <td>② Đánh dấu check vào ô đồng ý của màn hình Bản cam kết.</td>
              </tr>
              <tr>
                <td>③ Nhấn nút [Gửi đi] để nộp Bản cam kết.</td>
              </tr>
              <tr>
                <td class="lkt-title">7. Bảng khảo sát</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\manual-23.png" alt="" /></td>
              </tr>
              <tr>
                <td>
                  ① Khi nộp Bản cam kết thì tiến độ sẽ trở thành 90%. Click vào link [Bảng
                  khảo sát] ở trên thanh menu con, thì màn hình bảng khảo sát sẽ được hiển
                  thị.
                </td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\manual-24.png" alt="" /></td>
              </tr>
              <tr>
                <td>② Trả lời tất cả các câu hỏi trên màn hình bảng khảo sát.</td>
              </tr>
              <tr>
                <td>③ Nhấn nút [Gửi đi] để nộp Bảng khảo sát.</td>
              </tr>
              <tr>
                <td class="lkt-title">8. Tiến độ khóa học</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\manual-25.png" alt="" /></td>
              </tr>
              <tr>
                <td>
                  ① Nhấn vào biểu tượng [Tiến độ khóa học] ở phần trên màn hình , thì màn
                  hình yêu cầu hoàn thành sẽ được hiển thị.
                </td>
              </tr>
              <tr>
                <td>
                  ※ Màn hình Yêu cầu hoàn thành sẽ tự động xuất hiện sau khi hoàn thành bài
                  thi cuối kỳ, và Bảng khảo sát (nếu có), Bản cam kết (nếu có)
                </td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\manual-26.png" alt="" /></td>
              </tr>
              <tr>
                <td>② Xác nhận tình trạng tiến độ của khóa học.</td>
              </tr>
              <tr>
                <td>
                  ③ Khi hoàn thành xong cả Bảng khảo sát, thì button [Yêu cầu] sẽ trở thành
                  trạng thái được kích hoạt. Khi nhấn nhấn nút [Yêu cầu], thì khóa học đó sẽ
                  kết thúc.
                </td>
              </tr>
              <tr>
                <td>
                  ※ Sau khi kết thúc khóa học thì bạn không thể quay lại làm Bài thi cuối kỳ
                  được nữa.
                </td>
              </tr>
              <tr>
                <td class="lkt-title">9. Danh sách câu hỏi trả lời sai</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\manual-27.png" alt="" /></td>
              </tr>
              <tr>
                <td>
                  ① Sau khi nộp Bài thi cuối kỳ và được chấm, thì khi nhấn vào biểu tượng
                  [Câu hỏi trả lời không chính xác], thì màn hình Danh sách câu hỏi trả lời
                  sai sẽ được hiển thị.
                </td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\manual-28.png" alt="" /></td>
              </tr>
              <tr>
                <td>
                  ② Có thể xem đáp án đúng và lời giải của tất cả các câu hỏi bị trả lời
                  sai.
                </td>
              </tr>
              <tr>
                <td>
                  ③ Xóa ra khỏi danh sách câu trả lời sai: Xóa những câu hỏi tương ứng ra
                  khỏi danh sách câu hỏi bị trả lời sai.
                </td>
              </tr>
              <tr>
                <td class="lkt-title">10. Xác nhận thành tích</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\manual-29.png" alt="" /></td>
              </tr>
              <tr>
                <td>
                  ① Sau khi hoàn thành Bài thi cuối kỳ, nhấn vào biểu tượng [Thành tich],
                  thì màn hình Thành tích thi cuối kỳ sẽ được hiển thị.
                </td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\manual-30.png" alt="" /></td>
              </tr>
              <tr>
                <td>② Có thể tham chiếu thành tích của Bài thi cuối kỳ.</td>
              </tr>
              <tr>
                <td>
                  ③ Khi nhấn nút [Xem lịch sử dự thi], thì sẽ di chuyển đến màn hình Lịch sử
                  tham gia kì thi cuối kỳ.
                </td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\manual-31.png" alt="" /></td>
              </tr>
              <tr>
                <td>
                  ④ Khi nhấn nút [Quay lại], thì sẽ quay về màn hình tình Thành tích thi
                  cuối kỳ.
                </td>
              </tr>
              <tr>
                <td class="lkt-title">11. Tình trạng khóa học - Thành tích học tập</td>
              </tr>
              <tr>
                <td><i>11.1 Tình trạng khóa học</i></td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\manual-32.png" alt="" /></td>
              </tr>
              <tr>
                <td>
                  ① Khi nhấn vào biểu tượng [Tình hình học tập] trên thanh menu chính ở phía
                  trên màn hình, thì có thể tham chiếu tình trạng tiến độ học tập của khóa
                  học đã tham gia.
                </td>
              </tr>
              <tr>
                <td>
                  ② Khi nhấn vào biểu tượng Tình trạng khóa học, thì sẽ di chuyển đến màn
                  hinh chi tiết tiến độ của các khóa học đã tham gia.
                </td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\manual-33.png" alt="" /></td>
              </tr>
              <tr>
                <td><i>11.2 Thành tích học tập</i></td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\manual-34.png" alt="" /></td>
              </tr>
              <tr>
                <td>
                  Khi nhấn vào biểu tượng Thành tích học tập, thì sẽ di chuyển đến màn hinh
                  Thành tích học tập.
                </td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\manual-35.png" alt="" /></td>
              </tr>
              <tr>
                <td>
                  ※ Có thể bắt đầu khóa học bằng cách nhấn vào biểu tượng quyển sách trước
                  tên khóa học như hình.
                </td>
              </tr>
              <tr>
                <td class="lkt-title">12. Khóa học online</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\manual-36.png" alt="" /></td>
              </tr>
              <tr>
                <td>
                  Khi nhấn vào biểu tượng [Khóa học online] trên thanh menu chính ở phần
                  trên màn hình, thì có thể tham chiếu thông tin của bài giảng online.
                </td>
              </tr>
              <tr>
                <td class="lkt-title">13. Đăng xuất</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\manual-37.png" alt="" /></td>
              </tr>
              <tr>
                <td>
                  Ở trạng thái đang đăng nhập, khi nhấn vào biểu tượng Đăng xuất ở thanh
                  menu chính ở phần trên màn hình thì có thế đăng xuất ra khỏi hệ thống.
                </td>
              </tr>
              <tr>
                <td class="lkt-title">14. Xác nhận tiến độ (※Chỉ giành cho tài khoản có quyền quản lý※）</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\manual-38.png" alt="" /></td>
              </tr>
              <tr>
                <td>
                  ① Ở màn hình khái quát khóa học, nhấn nút [Xác nhận tiến độ], rồi di
                  chuyển đến màn hình Xác nhận tiến độ.
                </td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\manual-39.png" alt="" /></td>
              </tr>
              <tr>
                <td>
                  ② Nhập điều kiện tìm kiếm, nhấn nút [Tìm kiếm], rồi xác nhận kết quả tìm
                  kiếm.
                </td>
              </tr>
              <tr>
                <td>
                  ③ Nhấn nút [Xuất file], thì kết quả tìm kiếm sẽ được xuất ra dưới dạng
                  file Excel.
                </td>
              </tr>
            </table>
          </li>
          <li v-else>
            <table class="flex-table">
              <tr>
                <td class="lkt-title">1. Cài đặt Study-Arts dùng trên điện thoại</td>
              </tr>
              <tr>
                <td class="lkt-title">2. Chuyển đổi ngôn ngữ hiển thị</td>
              </tr>
              <tr>
                  <td><img src="../../../static\images\vi\mobile\manual-1.png" alt="" /></td>
                </tr>
              <tr>
                <td>Click icon quốc kỳ ở thanh menu chính của phần trên màn hình, có thể chuyển đổi ngôn ngữ hiển thị ở Pulldown menu.</td>
              </tr>
              <tr>
                <td class="lkt-title">3. Đăng nhập</td>
              </tr>
              <tr>
                  <td><img src="../../../static\images\vi\mobile\manual-2.png" alt="" /></td>
                <td><img src="../../../static\images\vi\mobile\manual-3.png" alt="" /></td>
                <td><img src="../../../static\images\vi\mobile\manual-4.png" alt="" /></td>
                </tr>
              <tr>
                <td>① Click icon Menu ở phía dưới màn hình, thì thanh Menu như trên sẽ xuất hiện từ phía bên trái màn hình.</td>
              </tr>
              <tr>
                <td>② Nhấn nút
                [Đăng nhập] ở phía trên màn hình</td>
              </tr>
              <tr>
                <td>③ Nhập thông
                tin vào ô Địa chỉ Email và Mật khẩu, rồi nhấn nút [Đăng nhập] thì thao tác
                đăng nhập sẽ được thực hiện</td>
              </tr>
              <tr>
                <td class="lkt-title">4. Thay đổi mật khẩu</td>
              </tr>
              <tr>
                  <td><img src="../../../static\images\vi\mobile\manual-5.png" alt="" /></td>
                <td><img src="../../../static\images\vi\mobile\manual-6.png" alt="" /></td>
                <td><img src="../../../static\images\vi\mobile\manual-7.png" alt="" /></td>
              </tr>
              <tr>
                <td>① Click icon
                Menu ở phía dưới màn hình, thì thanh Menu như trên sẽ xuất hiện từ phía bên
                trái màn hình.</td>
              </tr>
              <tr>
                <td>② Nhấn vào icon
                User bên trái icon Đăng nhập, sẽ xuất hiện màn hình thông tin người dùng như
                trên hình</td>
              </tr>
              <tr>
                <td>③ Nhấn vào dòng
                chữ [Đổi mật khẩu], sau đó nhập thông tin vào ô [Mật khẩu hiện tại], [Mật
                khẩu mới], [Mật khẩu mới (Xác nhận)]</td>
              </tr>
              <tr>
                <td>④ Nhấn nút [Lưu
                mật khẩu]</td>
              </tr>
              <tr>
                  <td><img src="../../../static\images\vi\mobile\manual-8.png" alt="" /></td>
              </tr>
              <tr>
                <td class="lkt-title">5. Tham gia
                khóa học</td>
              </tr>
              <tr>
                <td><i>5.1. Chọn khóa học</i></td>
              </tr>
              <tr>
                  <td><img src="../../../static\images\vi\mobile\manual-9.png" alt="" /></td>
                <td><img src="../../../static\images\vi\mobile\manual-10.png" alt="" /></td>
              </tr>
              <tr>
                <td>① Nhấn vào khóa
                học muốn học được hiển thị trên trang chủ hoặc tìm kiếm bằng từ khóa liên
                quan trong ô tìm kiếm.</td>
              </tr>
              <tr>
                <td>② Hoặc tìm kiếm
                bằng cách nhấn vào Icon Tìm kiếm và nhập từ khóa liên quan trong ô tìm kiếm.</td>
              </tr>
              <tr>
                  <td><img src="../../../static\images\vi\mobile\manual-11.png" alt="" /></td>
                <td><img src="../../../static\images\vi\mobile\manual-12.png" alt="" /></td>
              </tr>
              <tr>
                <td>③ Nhấn vào khóa học muốn học, sẽ di chuyển
                đến màn hình chi tiết khóa học</td>
              </tr>
              <tr>
                <td>④ Từ lần login sau, những khóa học đã tham
                gia sẽ được hiển thị trong Khóa học của tôi theo thứ tự ngày tham gia khi
                nhấn vào icon Khóa học của tôi</td>
              </tr>
              <tr>
                <td>※ Đối tượng tìm
                kiếm của thanh menu chính không phải chỉ là các khóa học của tôi, mà là toàn
                bộ hệ thống.</td>
              </tr>
              <tr>
                <td><i>5.2 Xem nội dung</i></td>
              </tr>
              <tr>
                  <td><img src="../../../static\images\vi\mobile\manual-13.png" alt="" /></td>
                <td><img src="../../../static\images\vi\mobile\manual-14.png" alt="" /></td>
                <td><img src="../../../static\images\vi\mobile\manual-15.png" alt="" /></td>
              </tr>
              <tr>
                <td>① Ở màn hình
                Khái quát khóa học, nhấn nút [Bắt đầu khóa học], di chuyển đến màn hình mục
                lục của khóa học muốn học</td>
              </tr>
              <tr>
                <td>② Nhấn vào tiêu
                đề 1 bài học trong Danh sách bài học, rồi học nội dung bài học đó.</td>
              </tr>
              <tr>
                <td>※ Tiêu đề có
                biểu tượng quyển sách phía trước là bài học có nội dung bên trong</td>
              </tr>
              <tr>
                <td>※ Khi nhấn vào
                bài học bất kỳ thì bài học đó được xem như là đang học, và chuyển từ màu đen
                sang màu đỏ.</td>
              </tr>
              <tr>
                <td>Nếu tất cả trang nội dung của từng bài
                học được hiển thị hết thì biểu tượng bài học sẽ chuyến thành màu xanh lá cây.</td>
              </tr>
              <tr>
                <td>③ Có thể chuyển
                đổi nội dung bằng các button [Về trước], [Đi tiếp] ở phía dưới màn hình</td>
              </tr>
              <tr>
                <td>※ Quay lại mục
                lục bằng biểu tượng [Mục lục], và di chuyển đến bài tập nhỏ bằng biểu tượng
                [Bài tập] ở phía dưới màn hình</td>
              </tr>
              <tr>
                <td>④ Có thể gửi
                câu hỏi liên quan đến bài học đang học cho giáo viên thông qua chức năng Trao
                đổi</td>
              </tr>
              <tr>
                <td>Nhấn vào icon [Mục lục] ở thanh menu
                bên dưới màn hình</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\mobile\manual-16.png" alt="" /></td>
                <td><img src="../../../static\images\vi\mobile\manual-17.png" alt="" /></td>
              </tr>
              <tr>
                <td>⑤ Có thể vừa
                học vừa ghi lại những lưu ý liên quan đến bài thông qua chức năng Ghi chú</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\mobile\manual-18.png" alt="" /></td>
              </tr>
              <tr>
                <td><i>5.3 Bài tập</i></td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\mobile\manual-19.png" alt="" /></td>
                <td><img src="../../../static\images\vi\mobile\manual-20.png" alt="" /></td>
              </tr>
              <tr>
                <td>① Nhấn biểu
                tượng Bài kiểm tra nhỏ ở bên phải mỗi
                bài học hoặc nhấn nút Bài kiểm tra nhỏ ở màn hình phía dưới mỗi bài học.</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\mobile\manual-21.png" alt="" /></td>
                <td><img src="../../../static\images\vi\mobile\manual-22.png" alt="" /></td>
              </tr>
              <tr>
                <td>② Xác nhận nội
                dung câu hỏi, rồi chọn đáp án từ các lựa chọn.</td>
              </tr>
              <tr>
                <td>③ Nhấn nút
                [Chấm bài] để nộp bài kiểm tra nhỏ. Khi đó, một hộp thoại xác nhận sẽ được
                hiển thị như hình bên dưới.</td>
              </tr>
              <tr>
                <td>Nhấn nút [OK] nếu bạn muốn được chấm bài,
                hoặc nút [Hủy] để tiếp tục làm bài kiểm tra.</td>
              </tr>
              <tr>
                <td>Sau khi nhấn nút [OK] để gửi chấm bài
                thì màn hình sẽ quay lại trang mục lục và xuất hiện dòng thông báo đã gửi bài
                kiểm tra như trong hình bên dưới.</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\mobile\manual-23.png" alt="" /></td>
                <td><img src="../../../static\images\vi\mobile\manual-24.png" alt="" /></td>
              </tr>
              <tr>
                <td>※ Sau chi nộp
                bài thì biểu tượng Bài tập sẽ chuyển từ màu đen sang màu đỏ.</td>
              </tr>
              <tr>
                <td>Sau khi bài tập được chấm thì biểu
                tượng Bài tập sẽ chuyển từ màu đỏ sang màu xanh lá cây, và đồng thời xuất
                hiện tỉ lệ % ở cột Tỷ lệ điểm</td>
              </tr>
              <tr>
                <td>④ Nhấn vào % sẽ
                xem được kết quả bài kiểm tra (câu trả lời đúng/sai và đáp án đúng)</td>
              </tr>
              <tr>
                <td>Những câu trả
                lời đúng sẽ có màu xanh lá cây, sai sẽ có màu cam.</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\mobile\manual-25.png" alt="" /></td>
                <td><img src="../../../static\images\vi\mobile\manual-26.png" alt="" /></td>
              </tr>
              <tr>
                <td>※ Bài kiểm tra
                nhỏ không phải là đối tượng để đánh giá tiến độ học tập hay thành tích họp
                tập. Cho dù không làm kiểm tra nhỏ thì vẫn có thể tiếp tục học và làm bài
                kiểm tra cuối kỳ.</td>
              </tr>
              <tr>
                <td><i>5.4 Bài thi cuối kỳ</i></td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\mobile\manual-27.png" alt="" /></td>
              </tr>
              <tr>
                <td>① Khi học xong
                toàn bộ nội dung trong danh sách bài học, thì biểu tượng Bài thi cuối kỳ sẽ
                được hiển thị trên đầu trang mục lục.</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\mobile\manual-28.png" alt="" /></td>
              </tr>
              <tr>
                <td>② Nhấn button
                [Bắt đầu kiểm tra], thì Kì thi cuối kỳ sẽ bắt đầu. Khi nhấn button [Hủy], thì
                sẽ quay trở lại màn hình Danh sách khóa học.</td>
              </tr>
              <tr>
                <td>※ Có thể làm
                bài kiểm tra cuối kỳ bao nhiêu lần cũng được. Việc phán đoán Đỗ/Không đỗ sẽ
                dựa vào thành tích cuối cùng.</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\mobile\manual-29.png" alt="" /></td>
              </tr>
              <tr>
                <td>③ Có thể
                chuyển đổi câu hỏi bằng biểu tượng mũi tên hoặc nhấn vào số câu hỏi bên dưới.
                Khi nhấn nút [Nộp bài], thì sẽ di chuyển đến màn hình xác nhận tình trạng trả
                lời.</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\mobile\manual-30.png" alt="" /></td>
              </tr>
              <tr>
                <td>※ Màu xanh: Đã
                trả lời, Màu xám: Chưa trả lời</td>
              </tr>
              <tr>
                <td>④ Kiểm ra lại
                tất cả các câu trả lời ở màn hình xác nhận tình trạng câu trả lời, rồi nhấn
                nút [Nộp bài], thì hộp thoại xác nhận nộp bài sẽ được hiển thị.</td>
              </tr>
              <tr>
                <td>⑤ Khi nhấn nút
                [OK], thì câu trả lời sẽ được nộp, và Bài thi cuối kỳ sẽ kết thúc.</td>
              </tr>
              <tr>
                <td class="lkt-title">6. Bản cam kết</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\mobile\manual-31.png" alt="" /></td>
                <td><img src="../../../static\images\vi\mobile\manual-32.png" alt="" /></td>
              </tr>
              <tr>
                <td>① Nếu đỗ Kì
                thi cuối kỳ thì % tiến độ sẽ tăng lên. Nhấn vào icon [Bản cam kết] trên thanh
                menu con, thì màn hình Bản cam kết sẽ được hiển thị.</td>
              </tr>
              <tr>
                <td>② Đánh dấu
                check vào ô đồng ý của màn hình Bản cam kết.</td>
              </tr>
              <tr>
                <td>③ Nhấn nút [Gửi
                đi] để nộp Bản cam kết.</td>
              </tr>
              <tr>
                <td class="lkt-title">7. Bảng khảo sát</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\mobile\manual-33.png" alt="" /></td>
                <td><img src="../../../static\images\vi\mobile\manual-34.png" alt="" /></td>
              </tr>
              <tr>
                <td>① Nhấn vào icon
                [Bảng khảo sát] ở trên thanh menu con, thì màn hình bảng khảo sát sẽ được
                hiển thị.</td>
              </tr>
              <tr>
                <td>② Trả lời tất
                cả các câu hỏi trên màn hình bảng khảo sát và đánh dấu vào ô xác nhận.</td>
              </tr>
              <tr>
                <td>③ Nhấn nút [Gửi
                đi] để nộp Bảng khảo sát.</td>
              </tr>
              <tr>
                <td class="lkt-title">8. Tiến độ khóa</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\mobile\manual-35.png" alt="" /></td>
                <td><img src="../../../static\images\vi\mobile\manual-36.png" alt="" /></td>
              </tr>
              <tr>
                <td>① Nhấn vào biểu
                tượng [Tiến độ khóa học] ở phần trên màn hình , thì màn hình yêu cầu hoàn
                thành sẽ được hiển thị.</td>
              </tr>
              <tr>
                <td>※ Màn hình Yêu
                cầu hoàn thành sẽ tự động xuất hiện sau khi hoàn thành bài thi cuối kỳ, và
                Bảng khảo sát (nếu có), Bản cam kết (nếu có)</td>
              </tr>
              <tr>
                <td>② Xác nhận tình
                trạng tiến độ của khóa học.</td>
              </tr>
              <tr>
                <td>③ Khi hoàn
                thành xong cả Bảng khảo sát, Bản cam kết thì button [Yêu cầu] sẽ trở thành
                trạng thái được kích hoạt (màu xanh). Khi nhấn nhấn nút [Yêu cầu], thì khóa
                học đó sẽ kết thúc.</td>
              </tr>
              <tr>
                <td>※ Sau khi kết
                thúc khóa học thì bạn không thể quay lại làm Bài thi cuối kỳ được nữa.</td>
              </tr>
              <tr>
                <td class="lkt-title">9. Danh sách câu hỏi trả lời sai</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\mobile\manual-37.png" alt="" /></td>
              </tr>
              <tr>
                <td>① Sau khi hoàn thành Bài thi cuối kỳ, nhấn vào biểu tượng [Câu hỏi
                trả lời không chính xác], thì màn hình Danh sách câu hỏi trả lời sai sẽ được
                hiển thị.</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\mobile\manual-38.png" alt="" /></td>
              </tr>
              <tr>
                <td>② Có thể xem
                đáp án đúng và lời giải của tất cả các câu hỏi bị trả lời sai.</td>
              </tr>
              <tr>
                <td>③ Xóa ra khỏi
                danh sách câu trả lời sai: Xóa những câu hỏi tương ứng ra khỏi danh sách câu
                hỏi bị trả lời sai.</td>
              </tr>
              <tr>
                <td class="lkt-title">10. Xác nhận thành tích</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\mobile\manual-39.png" alt="" /></td>
              </tr>
              <tr>
                <td>① Sau khi hoàn thành Bài thi cuối kỳ, nhấn vào biểu tượng [Thành
                tich], thì màn hình Thành tích thi cuối kỳ sẽ được hiển thị.</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\mobile\manual-40.png" alt="" /></td>
              </tr>
              <tr>
                <td>② Có thể tham
                chiếu thành tích của Bài thi cuối kỳ.</td>
              </tr>
              <tr>
                <td>③ Khi nhấn nút
                [Xem lịch sử dự thi], thì sẽ di chuyển đến màn hình Lịch sử tham gia kì thi
                cuối kỳ.</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\mobile\manual-41.png" alt="" /></td>
              </tr>
              <tr>
                <td>④ Nhấn vào dấu
                mũi tên để hiển thị thông tin chi tiết cho từng khóa học.</td>
              </tr>
              <tr>
                <td class="lkt-title">11. Tình trạng
                khóa học - Thành tích học tập</td>
              </tr>
              <tr>
                <td><i>11.1 Tình trạng khóa học</i></td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\mobile\manual-42.png" alt="" /></td>
              </tr>
              <tr>
                <td>① Khi nhấn vào biểu tượng [Tình hình học tập] trên thanh menu chính ở
                phía trên màn hình, thì có thể tham chiếu tình trạng tiến độ học tập của khóa
                học đã tham gia.</td>
              </tr>
              <tr>
                <td>② Khi nhấn vào biểu tượng Tình trạng khóa học, thì sẽ di chuyển đến
                màn hinh chi tiết tiến độ của các khóa học đã tham gia.</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\mobile\manual-43.png" alt="" /></td>
              </tr>
              <tr>
                <td><i>11.2 Thành tích học tập</i></td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\mobile\manual-44.png" alt="" /></td>
              </tr>
              <tr>
                <td>① Khi nhấn vào
                biểu tượng Thành tích học tập, thì sẽ di chuyển đến màn hinh Thành tích học
                tập.</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\mobile\manual-45.png" alt="" /></td>
              </tr>
              <tr>
                <td>② Nhấn vào dấu
                mũi tên để xem chi tiết thông tin về thành tích học tập của khóa học đó.</td>
              </tr>
              <tr>
                <td>③ Nhấn vào nút Hiển thị để xem lịch sử dự thi cuối kỳ của khóa học đó.</td>
              </tr>
              <tr>
                <td>④ Có thể tham gia khóa học bằng nút có biểu tượng quyển sách từ màn hình Thành tích học tập này</td>
              </tr>
              <tr>
                <td class="lkt-title">12. Khóa học online</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\mobile\manual-46.png" alt="" /></td>
                <td><img src="../../../static\images\vi\mobile\manual-47.png" alt="" /></td>
              </tr>
              <tr>
                <td>① Khi nhấn vào
                biểu tượng [Khóa học online] trên thanh menu chính ở phần trên màn hình, thì
                có thể tham chiếu thông tin của bài giảng online.</td>
              </tr>
              <tr>
                <td>② Có thể tìm
                kiếm 1 khóa học online theo các điều kiện tìm kiếm trong khung tìm kiếm.</td>
              </tr>
              <tr>
                <td>③ Danh sách các
                khóa học online sẽ được hiển thị ngắn gọn kèm theo biểu tượng và màu sắc theo
                trạng thái của khóa học.</td>
              </tr>
              <tr>
                <td>Chưa bắt đầu: Màu đen</td>
              </tr>
              <tr>
                <td>Đang dạy: Màu đỏ</td>
              </tr>
              <tr>
                <td>Đã kết thúc: Màu xanh lá cây</td>
              </tr>
              <tr>
                <td>※ Có thể xem chi tiết khóa học bằng cách nhấn vào dấu mũi tên nhỏ ở
                bên phải mỗi khóa học.</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\mobile\manual-48.png" alt="" /></td>
              </tr>
              <tr>
                <td class="lkt-title">13. Đăng xuất</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\mobile\manual-49.png" alt="" /></td>
                <td><img src="../../../static\images\vi\mobile\manual-50.png" alt="" /></td>
              </tr>
              <tr>
                <td>① Click icon
                Menu ở phía dưới màn hình, thì thanh Menu như trên sẽ xuất hiện từ phía bên
                trái màn hình.</td>
              </tr>
              <tr>
                <td>② Nhấn nút
                [Đăng xuất] ở phía trên màn hình</td>
              </tr>
              <tr>
                <td>14. Xác nhận
                tiến độ (※Chỉ giành cho tài khoản có quyền quản lý※）</td>
              </tr>
              <tr>
                <td>① Ở màn hình
                khái quát khóa học, nhấn nút [Xác nhận tiến độ], rồi di chuyển đến màn hình
                Xác nhận tiến độ.</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\mobile\manual-51.png" alt="" /></td>
              </tr>
              <tr>
                <td>② Nhập điều
                kiện tìm kiếm, nhấn nút [Tìm kiếm], rồi xác nhận kết quả tìm kiếm.</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\mobile\manual-52.png" alt="" /></td>
              </tr>
              <tr>
                <td class="lkt-title">Cách PWA hóa</td>
              </tr>
              <tr>
                <td>(sử dụng 1 website trên điện thoại giống như 1
                ứng dụng dùng cho điện thoại)</td>
              </tr>
              <tr>
                <td>①　Truy cập vào
                link study-arts.vn bằng Safari/Chrome/Firefox từ điện thoại</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\mobile\manual-53.png" alt="" /></td>
              </tr>
              <tr>
                <td>②　Mở【Add to
                Home Screen】ra để thêm icon vào màn hình chính</td>
              </tr>
              <tr>
                <td>■Safari</td>
              </tr>
              <tr>
                <td>
                <ul>
                <li>・Khi nhấn vào icon như bên dưới ở chính giữa thanh công cụ phía dưới màn hình, thì màn hình như hình bên phải sẽ được hiển thị.</li>
                <li>・Khi nhấn vào icon【Add to Home Screen】, thì việc cài đặt「StudyArts」sẽ hoàn thành.</li>
                </ul>
                </td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\mobile\manual-54.png" alt="" /></td>
              </tr>
              <tr>
                <td>■Chrome</td>
              </tr>
              <tr>
                <td>
                <ul>
                <li>・Khi nhấn vào biểu tượng dấu 3 chấm dọc, thì menu sẽ được hiển thị từ bên phải màn hình.</li>
                <li>・Khi nhấn vào icon[Add to Home screen] ỏ trên thanh menu thì, màn hình popup「Add to Home screen」sẽ được hiển thị.</li>
                <li>・Khi nhấn vào nút【Add】ở trên màn hình popup của「Add to Home screen」,sẽ di chuyển đến màn hình popup như bên dưới.</li>
                <li>・Khi nhấn vào nút【Add Automatically】, thì「StudyArts」dùng cho điện thoại sẽ được cài đặt.</li>
                </ul>
                </td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\mobile\manual-55.png" alt="" /></td>
              </tr>
              <tr>
                <td>■Firefox</td>
              </tr>
              <tr>
                <td>
                <ul>
                <li>・Khi nhấn vào biểu tượng dấu 3 chấm dọc, thì menu sẽ được hiển thị từ phía bên phải màn hình.</li>
                <li>・Khi nhấn vào icon [Cài đặt] ở trên thanh menu, thì「StudyArts」sẽ được cài đặt.</li>
                </ul>
                </td>
              </tr>
              <tr>
                <td><img src="../../../static\images\vi\mobile\manual-56.png" alt="" /></td>
              </tr>
            </table>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
//课程页轮播图
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import Element from "element-ui";
//国际化引入
import Vue from "vue";
import { mapMutations } from "vuex";
import { lang } from "../../assets/languages/getLanguageType.js";
Vue.prototype.$lang = lang;

export default {
  activeName: "second",
  name: "index",
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  props: ["userId"],
  data() {
    return {
      userIds: null,
      s1: null,
      s2: null,
      s3: null,
      s4: null,
      s5: null,
      sList: null,
      isMobileFlg: false, //設置課程分類用，手機版，下拉的顯示等
      arrowdownCss: true, //設置課程分類用，手機版，下拉的顯示等
      arrowdownIcon: true, //設置課程分類用，手機版，下拉的顯示等
      heightOut: 0, //設置課程分類用，手機版，下拉的顯示等
      heightIn: 0, //設置課程分類用，手機版，下拉的顯示等
      courseInfo: {},
      currentIndex1: -1,
      currentIndex2: -1,
      tagOne: null,
      tagTwo: null,
      loading: false,
      menuList: null,
      recommendCourse: {},
      itemList: [],
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
        },
        autoplay: {
          delay: 10000,
          disableOnInteraction: false, // 手动切换之后继续自动轮播
        },
        loop: true,
      },
    };
  },
  created() {
    //监听getMenuHeight
    window.addEventListener("resize", this.getMenuHeight);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getMenuHeight);
  },
  mounted() {
    //获取设备屏幕的高度
    // const h = document.body.clientHeight;
    // this.$refs.indexDiv.style.height = h + "px";
    setTimeout(() => {
      const that = this;
      if (that.$refs.heightOut != undefined) {
        that.heightOut = that.$refs.heightOut.offsetHeight;
        that.heightIn = that.$refs.heightIn.offsetHeight;
        // console.log(this.heightOut)
        // console.log(this.heightIn)
        if (that.heightOut < that.heightIn) {
          that.arrowdownIcon = true;
        } else {
          that.arrowdownIcon = false;
        }
      }
    }, 2000);

    this.userIds = window.sessionStorage.getItem("id");
    this.getMenuHeight();
    this.companyId = window.sessionStorage.getItem("companyId");

    //取得首页所有课程
    this.loading = true;
    this.$api
      .post("/home/getHomeCourseInfo", {
        languageType: this.$lang(),
      })
      .then((response) => {
        this.courseInfo = response.data;
        // console.log("首页的所有课程", this.courseInfo);
        this.recommendCourse = this.courseInfo.starCourse.courseList;
        this.menuList = this.courseInfo.starCourse.menuList;
        this.sList = this.courseInfo.frontList;
        if (this.sList != null) {
          for (var k = 0; k < this.sList.length; k++) {
            if (k == 0) {
              this.s1 = this.sList[k].imagePath;
            }
            if (k == 1) {
              this.s2 = this.sList[k].imagePath;
            }
            if (k == 2) {
              this.s3 = this.sList[k].imagePath;
            }
            if (k == 3) {
              this.s4 = this.sList[k].imagePath;
            }
            if (k == 4) {
              this.s5 = this.sList[k].imagePath;
            }
          }
        }
        this.loading = false;
      });

    if (this._isMobile()) {
      this.isMobileFlg = true; //手机端
      this.arrowdownIcon = false;
    } else {
      this.isMobileFlg = false; //pc端
    }
  },
  methods: {
    //移动端：滑动功能，增加css的方式。
    //PC端：显示下拉箭头
    getMenuHeight() {
      const that = this;
      if (that.$refs.heightOut != undefined) {
        that.heightOut = that.$refs.heightOut.offsetHeight;
        that.heightIn = that.$refs.heightIn.offsetHeight;
        // console.log(this.heightOut)
        // console.log(this.heightIn)
        if (that.heightOut < that.heightIn) {
          that.arrowdownIcon = true;
        } else {
          that.arrowdownIcon = false;
        }
      }
    },
    //作用：为primarymenu增加primarymenu-add
    cssedit() {
      this.arrowdownCss = !this.arrowdownCss;
    },

    //作用：判断终端设备
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },

    handleClick(el, a, b) {
      // console.log(el, a, b);
    },
    explore: function () {
      // 用 #explore 添加锚点
      let jump = document.querySelectorAll("#explore");
      let total = jump[0].offsetTop;
      let distance = document.getElementById("app").scrollTop;
      // 平滑滚动，时长500ms，每10ms一跳，共50跳
      let step = total / 50;
      if (total > distance) {
        smoothDown();
      } else {
        let newTotal = distance - total;
        step = newTotal / 50;
        smoothUp();
      }

      function smoothDown() {
        if (distance < total) {
          distance += step;
          document.getElementById("app").scrollTop = distance;
          setTimeout(smoothDown, 10);
        } else {
          document.getElementById("app").scrollTop = total;
        }
      }

      function smoothUp() {
        if (distance > total) {
          distance -= step;
          document.getElementById("app").scrollTopp = distance;
          setTimeout(smoothUp, 10);
        } else {
          document.getElementById("app").scrollTop = total;
        }
      }
    },
    go_regist: function () {
      this.$emit("info", "regist");
    },
    goRouter: function (url, tagOneId) {
      if (tagOneId) {
        this.$router.push({
          path: url,
          query: {
            tagOne: tagOneId,
          },
        });
      } else {
        this.$router.push(url);
      }
    },
    begin_start: function () {
      // console.log(document.getElementById("2"));
      //this.$router.push("/home/personSet");
    },
    ...mapMutations("header", ["setHistory"]),
    go_course: function (item, collegeId) {
      this.userIds = window.sessionStorage.getItem("id");
      if (this.userIds == "" || this.userIds == null) {
        this.$alert(window.vm.$i18n.t("js.PleaseLogin"), "", {
          confirmButtonText: window.vm.$i18n.t("js.confirm"),
        });
        return;
      } else {
        window.sessionStorage.setItem("courseGOBackNum", 1);
        this.setHistory("/home");
        this.$router.push({
          name: "Aicourse",
          query: {
            buyCourseId: item.courseId,
            buyCollegeId: collegeId,
          },
        });
      }
    },

    secondMenuChange: function (index1, id) {
      if (this.tagTwo == id) {
        return;
      }
      this.tagTwo = id;
      let allFlag = 1;
      if (id === -1) {
        //如果二级分类为-1，那就把一级id传给后台
        this.tagTwo = this.courseInfo.courses[index1].id;
        allFlag = 1;
      } else {
        allFlag = 0;
      }
      this.tagOne = this.courseInfo.courses[index1].id;
      this.loading = true;
      this.companyId = window.sessionStorage.getItem("companyId");
      this.$api
        .post("/home/getHomeCourseInfoChild", {
          id: this.tagTwo,
          allFlag: allFlag,
          languageType: this.$lang(),
        })
        .then((response) => {
          // console.log(response.data.courseList)
          this.courseInfo.courses[index1].courseList = response.data.courseList;
          this.loading = false;
        });
    },
    mouseOverUp($event) {
      $event.currentTarget.className = "el-icon-arrow-up oaa";
    },
    mouseLeaveUp($event) {
      $event.currentTarget.className = "el-icon-arrow-up up_laa";
    },
    mouseOverDown($event) {
      $event.currentTarget.className = "el-icon-arrow-down oaa";
    },
    mouseLeaveDown($event) {
      $event.currentTarget.className = "el-icon-arrow-down down_laa";
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main {
  padding-top: 60px;
}

a {
  text-decoration: none;
  color: white;
  -webkit-tap-highlight-color: white;
  -webkit-user-select: none;
  -moz-user-focus: none;
  -moz-user-select: none;
}
.l {
  float: left;
}
.r {
  float: right;
}
.clear::after {
  content: ".";
  display: block;
  clear: both;
  height: 0;
  visibility: hidden;
}
.container,
.bigCourse {
  width: 1200px;
  margin: 0 auto;
}

@media screen and (min-width: 1000px) and (max-width: 1200px) {
  .container,
  .bigCourse {
    width: 1000px;
  }
}
@media screen and (min-width: 800px) and (max-width: 1000px) {
  .container,
  .bigCourse {
    width: 800px;
  }
}
@media screen and (min-width: 600px) and (max-width: 800px) {
  .container,
  .bigCourse {
    width: 600px;
  }
}
@media screen and (max-width: 600px) {
  .container,
  .bigCourse {
    width: 400px;
  }
}
.swiper-container {
  margin-bottom: 20px;
  position: relative;
  /* overflow: hidden;
    height: 450px; */
}
.swiper-container img {
  width: 100%;
}

.primarylists {
  padding-top: 10px;
}

.primarylists > ul > li {
  padding-bottom: 20px;
  width: 1210px;
  overflow: hidden;
}
.primarylists ul li .titles {
  height: 35px;
  width: 1000px; /* 需要配合JS动态设置宽度 */
  padding-bottom: 5px;
  color: black;
  margin-bottom: 10px;
  display: flex;
  inline-size: max-content;
}

.secondlists {
  padding-left: 30px;
}
.secondlists > ul > li {
  padding-bottom: 10px;
  overflow: hidden;
}

.secondlists ul li .titles {
  height: 35px;
  width: 1000px; /* 需要配合JS动态设置宽度 */
  padding-bottom: 5px;
  padding-left: 5px;

  color: black;
  margin-bottom: 5px;
  display: flex;
  inline-size: max-content;
}

.secondlists ul li .titles .title {
  font-size: 22px;
  text-decoration: underline;
  line-height: 35px;
  font-weight: bold;
}

.secondlists ul li img {
  height: auto;
  width: 100%;
  margin-top: 10px;
  overflow: hidden;
}

.secondlists ul li p {
  font-size: 14px;
  margin-top: 10px;
}

.thirdlists {
  padding-left: 30px;
}
.thirdlists > ul > li {
  padding-bottom: 10px;
  padding-left: 30px;
  overflow: hidden;
}

.thirdlists ul li .titles {
  height: 35px;
  width: 1000px; /* 需要配合JS动态设置宽度 */
  padding-bottom: 5px;
  padding-left: 5px;
  color: black;
  margin-bottom: 5px;
  display: flex;
  inline-size: max-content;
}

.thirdlists ul li .titles .title {
  font-size: 22px;
  text-decoration: underline;
  line-height: 35px;
  font-weight: bold;
}

.thirdlists ul li img {
  height: auto;
  width: 100%;
  margin-top: 10px;
  overflow: hidden;
}

.thirdlists ul li p {
  font-size: 14px;
  margin-top: 10px;
}

.primarylists ul li .titles img {
  width: 32px;
  height: 32px;
  margin-top: 1px;
}
.primarylists ul li .titles .title {
  font-size: 24px;
  padding: 0 20px 0 10px;
  line-height: 35px;
  font-weight: bold;
}

.primarylists ul li .titles .more {
  font-size: 16px;
  line-height: 35px;
  cursor: pointer;
  padding-right: 20px;
}
.primarylists ul li .titles .more a {
  color: black;
}

.primarylists .secondlist {
  height: 100%;
  font-size: 16px;
}
.primarylists .secondlist ul li {
  float: left;
  padding: 3px 10px;
  cursor: pointer;
  margin-right: 16px;
  background: #666;
  border-radius: 15px;
  color: white;
}
.primarylists .secondlist ul li.choose {
  background: lightskyblue;
}

.primarylists .lessons ul {
  height: 350px;
  overflow: hidden;
  transform: translateX(5px);
}

.primarylists .lessons ul li {
  width: 190px;
  height: 170px;
  float: left;
  box-sizing: border-box;
  background: #333;
  background-clip: padding-box;
  margin-right: 10px;
  margin-bottom: 10px;
  border-radius: 10px;
  overflow: hidden;
}
.primarylists .lessons ul li:nth-of-type(1) {
  width: 390px;
  height: 350px;
}
.primarylists .lessons ul li:nth-of-type(1) .img {
  height: 200px;
}
.primarylists .lessons ul li .img {
  height: 100px;
  width: 100%;
  overflow: hidden;
}
.primarylists .lessons ul li .img img {
  width: 100%;
  transition: all 0.25s ease-in-out;
  -moz-transition: all 0.25s ease-in-out;
  -webkit-transition: all 0.25s ease-in-out;
  -o-transition: all 0.25s ease-in-out;
}
.primarylists .lessons .lessontitle {
  padding: 0px 10px;
  margin: 8px 0 3px;
  color: #f8f8f8;
  font-size: 15px;
  cursor: pointer;
  /* 1行溢出隐藏 */
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.primarylists .lessons .lessontitle:hover {
  color: lightskyblue;
}
.primarylists .lessons .introduce {
  padding: 0 10px;
  color: #999;
  font-size: 12px;

  /* 1行溢出隐藏 */
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  -webkit-line-clamp: 1;
  overflow: hidden;
}

.primarylists .lessons .islike {
  float: right;
  margin: 2px 10px 3px 0px;
  color: #f8f8f8;
  font-size: 10px;
  cursor: pointer;
  overflow: hidden;
}

.primarylists .lessons .islike span {
  float: right;
}

.primarylists .lessons ul li:nth-of-type(1) .lessontitle {
  font-size: 16px;
  padding: 15px 20px 0 20px;
  /* 2行溢出隐藏 */
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.primarylists .lessons ul li:nth-of-type(1) .introduce {
  font-size: 14px;
  line-height: 24px;
  padding: 10px 20px 0 20px;
  /* 3行溢出隐藏 */
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  -webkit-line-clamp: 3;
  overflow: hidden;
}

.footer {
  padding: 50px 0 30px 0;
  color: white;
  text-align: center;
  background: url(../../../static/images/bg/myCourseBackgroundFoot.jpg)
    no-repeat center bottom;
  background-size: cover;
}
.footer .line1 {
  font-size: 46px;
}
.footer .line2 {
  font-size: 14px;
  margin-bottom: 30px;
}
.footer .line3 {
  display: inline-block;
  padding: 5px 50px;
  border: 1px solid white;
  border-radius: 20px;
}
.footer .line3:hover {
  background: white;
  color: black;
  cursor: pointer;
}
.header {
  height: 60px;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: #121212;
  color: white;
  z-index: 10;
  opacity: 0.8;
}
.header ul li {
  float: left;
  margin-right: 30px;
}
.header .logo {
  padding-top: 12px;
  cursor: pointer;
}
.header .logo img {
  height: 36px;
}
.header ul li div {
  height: 12px;
  font-size: 12px;
  position: relative;
}
.header ul li:hover div {
  color: #999;
}
.header ul li div span {
  height: 16px;
  width: 16px;
  line-height: 16px;
  text-align: center;
  background: red;
  color: white;
  display: block;
  border-radius: 50%;
  position: absolute;
  bottom: -8px;
  right: -18px;
}
.header ul li p {
  padding-top: 5px;
  font-size: 20px;
  text-align: center;
  color: #409eff;
}

.header .right {
  padding-top: 10px;
}
.header .right .user > div {
  margin-right: 10px;
}
.header .right .user .photo {
  height: 40px;
  width: 40px;
  border-radius: 50%;
  overflow: hidden;
  cursor: pointer;
}
.header .right .user .photo img {
  width: 100%;
}
.header .right .user .name,
.header .right .user .logout {
  font-size: 22px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
}
.header .right .user .name:hover,
.header .right .user .logout:hover {
  color: #999;
}

.header .right .search {
  margin: 0 20px;
  font-size: 22px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
}
.header .right .search:hover {
  color: #999;
}
.header .right .flag {
  height: 40px;
  width: 60px;
  cursor: pointer;
  overflow: hidden;
  border-radius: 5px;
}
.header .right .flag img {
  width: 100%;
}
.swiper_bottom_shade {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 10;
  height: 200px;
  width: 100%;
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(rgba(224, 224, 219, 0)),
    to(#fff)
  );
  background: -webkit-linear-gradient(top, rgba(224, 224, 219, 0), #fff 100%);
  background: linear-gradient(180deg, rgba(224, 224, 219, 0), #fff 100%);
}
.bigCourse {
  position: relative;
}
.bigCourse ul {
  /*background-color: rgba(255,255,255,0.7);*/
  /*border-radius: 10px;*/
  /*padding: 30px 2% 0;*/
  width: 98%;
  margin: 0 1%;
  /*position: absolute;*/
  /*bottom: 10px;*/
  /*z-index: 9;*/
}

.bigCourse li a {
  font-size: 14px;
  background-image: -webkit-linear-gradient(315deg, #02adff 0%, #00d3ff 100%);
  background-image: linear-gradient(135deg, #02adff 0%, #00d3ff 100%);
  padding: 5px 15px;
  border-radius: 5px;
  margin-right: 20px;
  float: left;
  margin-bottom: 10px;
}
.bigCourse li a:hover {
  background-image: -webkit-linear-gradient(315deg, #00d3ff 0%, #02adff 100%);
  background-image: linear-gradient(135deg, #00d3ff 0%, #02adff 100%);
}
.showAllCourse {
  position: absolute;
  right: 10px;
  top: 5px;
  cursor: pointer;
}
.showAllCourse img {
  width: 19px;
}
/* .showAllCourse i{*/
/*  font-size: 20px;*/
/*   font-weight: bold;*/
/*   color: #666;*/
/*}*/
/*.showAllCourse i :hover{*/
/*  color: #02ADFF;*/
/*}*/
.primarymenu-add {
  height: 39px;
  overflow: hidden;
}
.boxout {
}
.boxout .boxin {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
}
.boxout .boxin li.SchoolBusiness_menu_li {
  box-sizing: border-box;
}
::-webkit-scrollbar {
  display: none;
}

.el-tabs >>> .el-tabs__active-bar {
  height: 30px;
  background-color: #02adff;
  border-radius: 25px;
  padding: 0 20px;
  margin-left: -20px;
  margin-bottom: 5px;
}
.el-tabs >>> .el-tabs__item {
  z-index: 2;
}
.el-tabs >>> .el-tabs__nav-wrap:after {
  height: 0px;
  background-color: none;
}
.el-tabs >>> .el-tabs__nav-scroll {
  padding: 0 20px;
}
.el-tabs >>> .el-tabs__item.is-active {
  color: #fff;
}
.el-tabs >>> .toolbar {
  padding-top: 20px;
}
.el-tabs >>> .el-pager {
  margin: 0 10px;
}
.vaa :hover {
  transform: scale(1.05, 1.05);
  cursor: pointer;
}
.down_laa {
  -webkit-text-stroke-width: 2px;
  color: #999;
}
.up_laa {
  -webkit-text-stroke-width: 2px;
  color: #00d3ff;
}
.oaa {
  -webkit-text-stroke-width: 2px;
  color: #ffb821;
}
.target-fix {
  position: relative;
  top: -60px;
  display: block;
  height: 0;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/index/manual_vi.vue